export * from '../_internal/operators/channelCapabilityGetters';
export { getEditorPluginsCapabilities } from '../_internal/operators/getEditorPluginsCapabilities';
export { getConfigurationKeyForFragment } from '../_internal/operators/getConfigurationKeyForFragment';
export { isConfigKeyGenericChannelId } from '../_internal/operators/isConfigKeyGenericChannelId';
export { getIsMetadataEditableAndVisible } from '../_internal/operators/getIsMetadataEditableAndVisible';